<template>
  <div class="white">
    <el-dialog
      title="白名单"
      :visible="value"
      width="1000px"
      :close-on-click-modal="false"
      @close="handleClose"
    >
      <div class="card-point tipBg">
        <div class="card-rule" style="min-width: 24px;"></div>
        <div class="card-connet">
          <p>白名单是针对订单号加白；订单号加白后，C端参与活动仍然要输入订单号解锁，但是加白的订单号不校验订单条件，直接解锁成功；加白后仅不校验订单条件，但仍然需遵循活动条件、抽奖规则（仅可解锁1个订单或可解锁多个订单）、中奖限制、发奖规则等。</p>
        </div>
      </div>
      <div class="white-btn">
        <el-button type="primary" @click="addList">新增白名单</el-button>
      </div>
      <!-- 表格 -->
      <el-table v-loading="tableLoading" :data="whitelistData" style="width: 100%;border: 1px solid #eee" :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }">
        <template slot="empty">
          <div>
            <img src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png" />
            <span style="margin-left: -140px">暂无任何数据</span>
          </div>
        </template>
        <el-table-column prop="chaosPin" label="用户pin">
          <template slot-scope="scope">
            <span class="table-box">
              <span class="hover-show"
                v-if="!scope.row.showPin"
                @click="handleShowDetail(scope.row)"
              >
                显示全部
              </span>
              <span class="table-box-text">{{scope.row.showPin ? scope.row.customerPin: scope.row.chaosPin}}</span> 
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="orderStr" label="订单号" show-overflow-tooltip></el-table-column>
        <el-table-column
          prop="updateTime"
          label="最后添加时间"
        ></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="addOrder(scope.row)">新增</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="white-page">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.current"
          :page-sizes="[5, 10, 20, 30, 50, 100]"
          :page-size="page.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
          ></el-pagination>
      </div>
      <div slot="footer">
        <el-button @click="handleClose" style="margin-right: 8px">取消</el-button>
        <el-button type="primary" @click="handleSecondConfirm">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="新增白名单"
      width="500px"
      append-to-body
      :visible.sync="addDialog"
      :close-on-click-modal="false"
      @close="handleAddClose"
    >
      <el-form ref="addFormRef" :model="addForm" :rules="addRules" class="new-input-box" label-width="auto">
        <el-form-item label="用户pin：" prop="customerPin">
          <el-input v-model="addForm.customerPin" placeholder="请输入京东账号名" :disabled="orderRow.customerPin?true:false"></el-input>
        </el-form-item>
        <el-form-item label="订单号：" prop="orderStr">
          <el-input v-model="addForm.orderStr" placeholder="多个之间用英文逗号隔开"></el-input>
        </el-form-item>
        <el-form-item label-width="0px">
          <div class="card-point tipBg">
          <div class="card-rule" style="min-width: 24px;"></div>
          <div class="card-connet">
            <p>1.用户pin需与订单号下单的用户pin一致，否则无法保存；</p>
            <p>2.输入多个订单号需确认抽奖规则（仅可解锁1个订单或可解锁多个订单），如仅可解锁1个订单，则输入多个也不生效解锁多个。 </p>
            <p>3. 保存后不支持修改，务必确认订单号无误后保存。</p>
          </div>
        </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="gley" @click="handleAddClose" style="margin-right: 8px">取消</el-button>
        <el-button type="primary" @click="handleSaveConfirm">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import tipBox from "@/components/tip-box"
import {pointActivityWhite,pointActivityAddOrUpdate} from "@/api/integralCenter/PointActivityAnalyticController";
export default {
  props:{
    value:{
      type:Boolean,
      default:false
    },
    whiteRow:{
      type:Object,
      require:true
    }
  },
  components:{
    tipBox
  },
  data(){
    return {
      whitelistData:[],
      tableLoading:false,
      page:{
        current:1,
        size:10,
        total:0
      },
      addDialog:false,
      addForm:{
        customerPin:null,
        orderStr:null
      },
      addRules:{
        customerPin:{required:true,message:'请填写用户pin',trigger:'blur'},
        orderStr:{required:true,message:'请填写订单号',trigger:'blur'}
      },
      orderRow:{}
    }
  },
  created(){
    this.getDataList()
  },
  methods:{
    getDataList(){
      const query = {
        current:this.page.current,
        size:this.page.size,
        activityType: 1,
        activityId:this.whiteRow.id
      }
      this.tableLoading = true
      pointActivityWhite(query).then(res=>{
        this.tableLoading = false
        this.whitelistData = res.data.records
        this.page.total = Number(res.data.total)
      }).catch(()=>{
        this.tableLoading = false
      })
    },
    // 新增白名单
    addList(){
      this.orderRow = {}
      this.addDialog = true
    },
    // 新增订单
    addOrder(row){
      this.addDialog = true
      this.orderRow = row
      this.addForm.customerPin = row.customerPin
    },
    // 分页数量
    handleSizeChange(size){
      this.page.size = size;
      this.getDataList();
    },
    // 分页数量
    handleCurrentChange(current){
      this.page.current = current;
      this.getDataList();
    },
    // 弹窗关闭
    handleClose(){
      this.$emit('input',false)
    },
    // 确定
    handleSecondConfirm(){
      this.$emit('input',false)
    },
    // 新增弹窗关闭
    handleAddClose(){
      this.addDialog = false
      this.$refs.addFormRef.resetFields()
    },
    // 新增保存
    handleSaveConfirm(){
      this.$refs.addFormRef.validate(valid=>{
        if(valid){
          const {customerPin,orderStr} = this.addForm
          const query = {
            customerPin,
            orderStr,
            activityType: 1,
            activityId:this.whiteRow.id
          }
          if(this.orderRow.id){
            query.id = this.orderRow.id
          }
          pointActivityAddOrUpdate(query).then(res=>{
            if(res.code != 1)return this.$message.error(res.message)
            this.page.current = 1
            this.getDataList()
            this.handleAddClose()
          })
        }
      })
    },
    // pin显示隐藏
    handleShowDetail(row){
      this.$set(row,'showPin',true)
    }
  }
};
</script>

<style lang="scss" scoped>
.white{
  &-btn{
    margin-top: 20px;
    margin-bottom: 16px;
  }
  &-page{
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  }
}
.table-box{
  position: relative;
  min-width: 80px;
  .hover-show {
    display: none;
    position: absolute !important;
    left: 0%;
    top: 50%;
    text-align: center;
    transform: translate(0, -50%);
    color: #7B61FF;
    cursor: pointer;
    padding: 1px 10px;
    border-radius: 4px;
    z-index: 999;
    width: 100%;
    min-width: 80px;
  }
  &-text{
    white-space: nowrap;
    padding-left: 4px;
  }
}
.table-box:hover {
  .hover-show {
    display: inline-block;
    background: #E9F0FF;
    color: #7B61FF;
  }
}
.card-point {
  width: 100%;
  background: #fffaee;
  border-radius: 4px;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 9px 14px;
  display: flex;
  .card-rule {
    background: url("~@/assets/images/new_icon_reminder.png") no-repeat;
    background-size: 14px 14px;
    margin-top: 4px;
  }
  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}
</style>